import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllPrompts,
  GetPromptById,   // optional: in case you need it later
  CreatePrompt,
  EditPrompt,
  DeletePrompt,
} from "../../services/prompts"; // Adjust the path if needed

// ──────────────────────────────
// Initial State
// ──────────────────────────────
const initialState = {
  prompts: [],
  loading: false,
  error: null,
};

// ──────────────────────────────
/** Slice */
// ──────────────────────────────
const promptSlice = createSlice({
  name: "prompts",
  initialState,
  reducers: {
    setPrompts: (state, { payload }) => {
      state.prompts = payload;
    },
    removeSinglePrompt: (state, { payload }) => {
      state.prompts = state.prompts.filter((i) => i.id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // ───── GET ALL ─────
      .addCase(getAllPromptsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPromptsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.prompts = action.payload;
      })
      .addCase(getAllPromptsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // ───── CREATE ─────
      .addCase(createPromptAsync.fulfilled, (state, action) => {
        state.prompts.push(action.payload);
      })

      // ───── EDIT ─────
      .addCase(editPromptAsync.fulfilled, (state, action) => {
        const index = state.prompts.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.prompts[index] = {
            ...state.prompts[index],
            ...action.payload.updated,
          };
        }
      })

      // ───── DELETE ─────
      .addCase(deletePromptAsync.fulfilled, (state, action) => {
        state.prompts = state.prompts.filter((p) => p.id !== action.payload);
      });
  },
});

// ──────────────────────────────
/** Async Thunks */
// ──────────────────────────────
export const getAllPromptsAsync = createAsyncThunk(
  "prompts/getAllPromptsAsync",
  async () => {
    const response = await GetAllPrompts();
    return response;
  }
);

// Optional single fetch thunk if you plan to use it in a details page/view
export const getPromptByIdAsync = createAsyncThunk(
  "prompts/getPromptByIdAsync",
  async (id) => {
    const response = await GetPromptById(id);
    return response;
  }
);

export const createPromptAsync = createAsyncThunk(
  "prompts/createPromptAsync",
  async (payload) => {
    const response = await CreatePrompt(payload);
    return response;
  }
);

export const editPromptAsync = createAsyncThunk(
  "prompts/editPromptAsync",
  async ({ id, payload }) => {
    const response = await EditPrompt(id, payload);
    // Keep same contract as your headings slice: return { id, updated }
    return { id, updated: response };
  }
);

export const deletePromptAsync = createAsyncThunk(
  "prompts/deletePromptAsync",
  async (id) => {
    await DeletePrompt(id);
    return id;
  }
);

// ──────────────────────────────
/** Exports */
// ──────────────────────────────
export const { setPrompts, removeSinglePrompt } = promptSlice.actions;

export default promptSlice.reducer;
